<ng-container *ngIf="!isMobile; else mobileSidebar">
  <aside class="sidebar sidebar--desktop">
    <app-sidebar-content (navigate)="onLinkClick()"></app-sidebar-content>
  </aside>
</ng-container>

<ng-template #mobileSidebar>
  <div class="sidebar-backdrop" [class.sidebar-backdrop--open]="mobileOpen" (click)="onBackdropClick()">
    <aside class="sidebar sidebar--mobile" [class.sidebar--mobile-open]="mobileOpen" (click)="$event.stopPropagation()">
      <div class="sidebar__mobile-header">
        <button type="button" class="sidebar__close-btn" (click)="close()">
          <hugeicons-icon [icon]="Cancel01Icon" [strokeWidth]="2"></hugeicons-icon>
        </button>
      </div>

      <app-sidebar-content (navigate)="onLinkClick()"></app-sidebar-content>
    </aside>
  </div>
</ng-template>